module.exports = __webpack_public_path__ + "static/media/envelope-icon-form.e83943ac.svg";